// Bright MLS IDX disclaimer — VERBATIM (A.6), required wherever live listing
// data renders. Extracted so /listings and every /areas/* page share one source.
// `compact` keeps the verbatim text but tucks it inside a tiny hover/tap
// popover (native <details> — click/tap everywhere, hover-open on mice) so
// dense layouts like the home-page map embed aren't dominated by legal copy.
const DISCLAIMER =
  'The data relating to real estate for sale on this website appears in part through the BRIGHT Internet Data Exchange program, a voluntary cooperative exchange of property listing data between licensed real estate brokerage firms in which Jack Lingo REALTOR\u00ae participates, and is provided by BRIGHT through a licensing agreement. The information provided by this website is for the personal, non-commercial use of consumers and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Some properties which appear for sale on this website may no longer be available.'

export default function MlsDisclaimer({ compact = false }: { compact?: boolean }) {
  if (compact) {
    return (
      <div className="mt-4 flex items-center justify-center">
        <details className="group relative">
          <summary
            className="flex cursor-pointer list-none items-center gap-1.5 text-[10px] uppercase tracking-[0.15em] text-white/40 transition-colors hover:text-white/70 [&::-webkit-details-marker]:hidden"
            onMouseEnter={(e) => (e.currentTarget.parentElement as HTMLDetailsElement).open = true}
            onMouseLeave={(e) => (e.currentTarget.parentElement as HTMLDetailsElement).open = false}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Listing data courtesy of Bright MLS · IDX disclaimer</span>
          </summary>
          <div className="absolute bottom-full left-1/2 z-30 mb-2 w-[min(20rem,80vw)] -translate-x-1/2 rounded-lg border border-white/15 bg-primary-ink p-4 shadow-2xl">
            <p className="text-[10px] leading-relaxed text-white/70">{DISCLAIMER}</p>
            <p className="mt-2 text-[10px] text-white/70">
              ©2026 BRIGHT MLS, All Rights Reserved. Information deemed reliable but not guaranteed.
            </p>
          </div>
        </details>
      </div>
    )
  }
  return (
    <div className="mt-8 border-t border-white/10 pt-6">
      <p className="text-[11px] leading-relaxed text-white/60 max-w-4xl">{DISCLAIMER}</p>
      <p className="mt-2 text-[11px] text-white/60">
        ©2026 BRIGHT MLS, All Rights Reserved. Information deemed reliable but
        not guaranteed.
      </p>
    </div>
  )
}
